import { usePageEventContext, withPageEvent } from '../../../shared/flow-event';
import { createInitialState, createTracker } from './tracker';
import type {
  LoginByOtpOneCredentialFlowEventDefinition,
  LoginByOtpOneCredentialFlowEventState,
} from './types';

export function useLoginByOtpOneCredentialFlowEvent() {
  return usePageEventContext<LoginByOtpOneCredentialFlowEventDefinition>();
}

export function withLoginByOtpOneCredentialFlowEvent<
  Props extends object = {}
>() {
  return withPageEvent<
    LoginByOtpOneCredentialFlowEventDefinition,
    LoginByOtpOneCredentialFlowEventState,
    Props
  >(createInitialState(), createTracker());
}
